// @flow

import type {Action} from '../../types';
import type {ReportStore} from '../types';

import {SET_AVAILABLE, SET_ERROR, SET_FETCHING} from '../actions/report';

const initialState: ReportStore = {
  available: false,
  fetching: false,
  isError: false
};

export default (state: ReportStore = initialState, action: Action) => {
  switch (action.type) {
    case SET_AVAILABLE:
      return {
        ...state,
        available: action.payload
      };
    case SET_FETCHING:
      return {
        ...state,
        fetching: action.payload
      };
    case SET_ERROR:
      return {
        ...state,
        isError: action.payload
      };
    default:
      return state;
  }
};
